<div class="cta-section">
  <button
    class="cta-btn"
    type="button"
    (click)="submitPressed.emit()"
    [disabled]="!canSubmit || loading"
  >
    <ion-icon *ngIf="!loading" name="paper-plane"></ion-icon>
    <span *ngIf="!loading">{{ "UX_TEXT.DEMANDE.CTA.SUBMIT" | translate }}</span>
    <app-spinner *ngIf="loading"></app-spinner>
  </button>
  <button class="cta-cancel" type="button" (click)="cancelPressed.emit()">
    {{ "UX_TEXT.DEMANDE.CTA.CANCEL" | translate }}
  </button>
</div>

<div class="trust-bar">
  <span class="trust-item">
    <ion-icon name="logo-euro" style="color: #d4ab0f"></ion-icon>
    {{ "UX_TEXT.DEMANDE.CTA.FREE_QUOTE" | translate }}
  </span>
  <span class="trust-item">
    <ion-icon name="timer-outline" style="color: #1d5d9b"></ion-icon>
    {{ "UX_TEXT.DEMANDE.CTA.RESPONSE_15" | translate }}
  </span>
  <span class="trust-item">
    <ion-icon name="shield-checkmark" style="color: #10b981"></ion-icon>
    {{ "UX_TEXT.DEMANDE.CTA.VERIFIED_PROS" | translate }}
  </span>
</div>
